import Component from '@glimmer/component';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import BaseAntecedentsFields from '../base-antecedents-fields';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient?: unknown;
  };
}

export default class MyComponent extends Component<Signature> {
  BaseAntecedentsFields = BaseAntecedentsFields;

  <template>
    <this.BaseAntecedentsFields @form={{@form}} @patient={{@patient}} />
  </template>
}
